module.exports = __webpack_public_path__ + "static/media/edit.be9c3b18.svg";